const Territory = require('../../entities/Territory');
const { Age }  = require("../Constants");
const TerritoryNames = require("../Names/TerritoryNames");

class DevelopedTerritory extends Territory {
    constructor(age){
        super(
            age,
            TerritoryNames.DevelopedTerritory,
            "Gain " + DevelopedTerritory.GetCubeCount(age) + " blue & yellow cubes and gain " + DevelopedTerritory.GetScienceCount(age) + " science.",
            {}
        )
    }

    static GetCubeCount(age)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 1;
            case Age.Age2:
                return 2;
        }
    }

    static GetScienceCount(age)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 3;
            case Age.Age2:
                return 5;
        }
    }
}

module.exports = DevelopedTerritory;